// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimTypes = t.struct({
    allowed: t.Array,
    selected: t.Array
}, 'ClaimTypes');

export const getDefaultState = () =>
    new ClaimTypes({
        allowed: [],
        selected: []
    });

export default ClaimTypes;



// WEBPACK FOOTER //
// ./src/reports/credit-memo/state/claim-types.js